<div >
  <span aria-live="polite" aria-relevant="text" aria-atomic="true" class="hide-text-screenreader-only" #paginationArialLiveRegion></span>
    <div class="dropdown-container" #selectElement>
      <div [ngStyle]="{'maxWidth': '30rem'}">
        <c11n-select
          (stateChange)="changePage($event)"
          [hideLabel]="true"
          [hasCustomHintError]="true"
        >
          <select [attr.aria-label]="paginationLabel" c11nSelectInput id="{{paginationLabel + 'SelectId'}}" >
            <option *ngFor="let page of pages" [value]="page" class="pagination-text">
              {{(page - 1)*PAGE_SIZE + 1}}-{{(page*PAGE_SIZE < listSize) ? (page*PAGE_SIZE) : listSize}} of
              {{listSize}}&nbsp;&nbsp;&nbsp;Page {{page}}
            </option>
          </select>
        </c11n-select>
      </div>
    </div>
</div>
